export default __webpack_public_path__ + "static/3-c17acbc8d2dd5a39f9e00e4ba5f26548.png";